import React, { useState, useEffect } from 'react';
import { AiFillPlusCircle } from 'react-icons/ai';
import { FiBatteryCharging } from 'react-icons/fi';
import { GoGear } from 'react-icons/go';
import { IoIosCloseCircleOutline } from 'react-icons/io';
import { Link } from 'react-router-dom';
import Input from '../common/Input';
import { IoMdList } from 'react-icons/io';
import DataTable from '../common/DataTable';
import AdminNavigation from './AdminNavigation';
import { getVendorAccounts } from '../service/vendorService';
import TooltipBox from '../common/TooltipBox';
import { isAdmin } from '../service/authService';
import { toast } from 'react-toastify';

export default function VendorList(props) {
   const [items, setItems] = useState([]);
   const [filterValue, setFilterValue] = useState('');
   const [accounts, setAccounts] = useState([]);
   const user = JSON.parse(localStorage.getItem('user'));
   const checkAdmin = isAdmin();

   const iconStyleCharging = {
      color: '#2c62a9',
      fontSize: 15,
      cursor: 'pointer',
   };

   const iconStyleFloat = {
      color: '#1D7500',
      fontSize: 15,
      cursor: 'pointer',
   };

   const iconStyleDisable = {
      color: '#A70329',
      fontSize: 15,
      cursor: 'pointer',
   };

   const iconStyle = {
      color: '#2c62a9',
      fontSize: 30,
      cursor: 'pointer',
   };

   const pageSize = 50;
   const columns = [
      {
         columnCaption: 'Account Id',
         columnKey: 'vendorAccountId',
         content: (item) => <span style={{ fontSize: 10 }}>{item.vendorAccountId}</span>,
      },
      {
         columnCaption: 'Account Name',
         columnKey: 'vendorAccountName',
      },
      {
         columnCaption: 'Contact Number',
         columnKey: 'vendorMsisdn',
      },
      {
         columnCaption: 'Balance',
         columnKey: 'vendorAccountBalance',
         content: (item) => <>{formatNumber(item.vendorAccountBalance)}</>,
      },
      {
         columnCaption: 'Warning Balance',
         columnKey: 'refillWarningBalance',
         content: (item) => <>{formatNumber(item.refillWarningBalance)}</>,
      },
      {
         columnCaption: 'Float Account',
         columnKey: 'floatAccount.floatAccountName',
      },
      {
         columnCaption: 'Actions',
         content: (item) => {
            if (checkAdmin) {
               return (
                  <>
                     <span className='mr-3'>
                        <Link to={`/VendorRecharge/${item.vendorAccountId}`}>
                           <TooltipBox text='Recharge' component={<FiBatteryCharging style={iconStyleCharging} />} />
                        </Link>
                     </span>
                     <span className='mr-3'>
                        {/* <Link to={`/User/${item.vendorAccountId}`}> */}
                        <TooltipBox text='Assign Float' component={<GoGear style={iconStyleFloat} />} />
                        {/* </Link> */}
                     </span>
                     <span className='mr-3'>
                        {/* <Link to={`/User/${item.vendorAccountId}`}> */}
                        <TooltipBox text='Disable' component={<IoIosCloseCircleOutline style={iconStyleDisable} />} />
                        {/* </Link> */}
                     </span>
                  </>
               );
            }
         },
      },
   ];

   const onSearch = (e) => {
      e.preventDefault();
      let value = e.target.value;
      setFilterValue(value);
      let searchItems = [...accounts];
      let filteredItems = [];
      if (value !== '') {
         filteredItems = searchItems.filter((dataItem) => {
            return (
               dataItem.vendorAccountId === parseInt(value) ||
               dataItem.vendorAccountName.includes(value) ||
               dataItem.vendorMsisdn.toUpperCase().includes(value.toUpperCase()) ||
               dataItem.vendorAccountBalance.toString().includes(value) ||
               dataItem.refillWarningBalance.toString().includes(value)
            );
         });
      } else {
         filteredItems = [...accounts];
      }
      setItems(filteredItems);
   };

   const formatNumber = (input) => {
      return new Intl.NumberFormat('en-US', {}).format(input);
   };

   const fetchVendorAccounts = () => {
      if (checkAdmin) {
         getVendorAccounts()
            .then((result) => {
               const vendorAccounts = result.data.data;
               setItems(vendorAccounts);
               setAccounts((prevState) => {
                  return prevState.concat(vendorAccounts);
               });
            })
            .catch((error) => {
               toast.error('Error occurs !! Could not load vendors accounts');
            });
      } else {
         const newAccounts = user.accounts;
         setItems(newAccounts);
         setAccounts(newAccounts);
      }
   };

   useEffect(fetchVendorAccounts, []);

   return (
      <>
         <div className='container'>
            <div className='row'>
               <div className='col-md-3'>
                  <AdminNavigation />
               </div>
               <div className='col-md-9'>
                  <h4 className='text-muted ml-1 mb-2 font-italic'>Vendors Accounts</h4>
                  <div className='input-group input-group-sm mb-3 mr-sm-2'>
                     <div className='input-group-prepend'>
                        <div className='input-group-text'>
                           <IoMdList />
                        </div>
                     </div>
                     <Input
                        name='searchBox'
                        type='text'
                        className='form-control custom-input'
                        id='searchBox'
                        value={filterValue}
                        placeholder=''
                        onChange={onSearch}
                     />
                  </div>
                  <div className='mb-1'>
                     <AiFillPlusCircle style={iconStyle} />
                  </div>
                  <div className='table-responsive'>
                     <DataTable items={items} pageSize={pageSize} fontClassName={'table-font-sm'} columns={columns}></DataTable>
                  </div>
               </div>
            </div>
         </div>
      </>
   );
}
